import { render } from "./MovimentacaoEstoqueIndex.vue?vue&type=template&id=496778ed&scoped=true&ts=true"
import script from "./MovimentacaoEstoqueIndex.vue?vue&type=script&lang=ts"
export * from "./MovimentacaoEstoqueIndex.vue?vue&type=script&lang=ts"

import "./MovimentacaoEstoqueIndex.vue?vue&type=style&index=0&id=496778ed&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496778ed"]])

export default __exports__